import { FileCard } from "#features/conversations/components/files/FileCard.tsx";
import type { FileModel } from "#features/conversations/types/FileModel.ts";
import { Div, Flex } from "@hopper-ui/components";

interface Props {
    files: FileModel[];
    removeFile: (file: FileModel) => void;
}

export const ConversationInputFiles = ({ files, removeFile }: Props) => {
    return (
        <Div
            overflowX="auto"
            UNSAFE_borderTopLeftRadius="2rem"
            UNSAFE_borderTopRightRadius="2rem"
            paddingLeft={{ base: "inset-sm", sm: "inset-md" }}
            paddingY="inset-sm"
        >
            <Flex
                position="relative"
                zIndex={1}
                alignItems="center"
                gap="inline-sm"
            >
                {files.map(file => (
                    <Div
                        key={file.id}
                        flexShrink={0}
                    >
                        <FileCard
                            file={file}
                            onRemove={() => removeFile(file)}
                        />
                    </Div>
                ))}
                {/* Add empty div for padding right when parent div overflows */}
                <Div
                    width="core_10"
                    height="core_10"
                    flexBasis={{ base: "0.125rem", sm: "0.4375rem" }}
                    flexShrink={0}
                />
            </Flex>
        </Div>
    );
};
